import { useEffect, useState } from 'react';

const DELAY = 500;
export default function useShowSkeletonDelay(ignoreSkeleton = true): boolean {
  const [show, setShow] = useState(!ignoreSkeleton);

  useEffect(() => {
    const timer = setTimeout(() => setShow(false), DELAY);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return show;
}
